import SignUp from './SignUp.vue';

export default SignUp;
